import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ApplyPanelComponent, CheckboxComponent, NumberInputComponent } from '@imagise/shared';
import { EditMode } from '../../../domain/enums/editor.enum';
import { EditorResizeDraftOperation } from '../../../domain';
import { Size2D } from '../../../domain/interfaces/shared';
import { ResizeViewModel } from '../../../domain/models/resize-view-model';
import { EditOptionsPanelBase } from '../edit-options-panel.base';
import { PanelLayoutComponent } from '../panel-layout/panel-layout.component';

@Component({
  selector: 'lib-resize-panel',
  host: {
    class: 'contents',
  },
  templateUrl: './resize-panel.component.html',
  imports: [NumberInputComponent, CheckboxComponent, ApplyPanelComponent, PanelLayoutComponent, TranslateModule],
})
export class ResizePanelComponent extends EditOptionsPanelBase<EditorResizeDraftOperation> {
  private imageSize$: Size2D | null = null;
  @Input() set imageSize(value: Size2D | null) {
    this.changed.reset();
    this.imageSize$ = value;
    if (value) {
      this.viewModel = new ResizeViewModel(value);
      this.emitResizeOptions();
    } else {
      this.viewModel = null;
    }
  }

  /**
   * Editor options
   */

  viewModel: ResizeViewModel | null = null;

  onWidthPixelsChanged(value: number): void {
    if (!this.viewModel) return;
    this.viewModel.width = value;
    this.emitResizeOptions();
  }

  onHeightPixelsChanged(value: number): void {
    if (!this.viewModel) return;
    this.viewModel.height = value;
    this.emitResizeOptions();
  }

  onWidthPercentageChanged(value: number): void {
    if (!this.viewModel) return;
    this.viewModel.scaleXPercentage = value;
    this.emitResizeOptions();
  }

  onHeightPercentageChanged(value: number): void {
    if (!this.viewModel) return;
    this.viewModel.scaleYPercentage = value;
    this.emitResizeOptions();
  }

  onKeepAspectChanged(keepAspect: boolean): void {
    if (!this.viewModel) return;
    this.viewModel.keepAspectRatio = keepAspect;
    this.emitResizeOptions();
  }

  private emitResizeOptions() {
    if (!this.viewModel) return;
    this.changed.emit({
      kind: 'resize',
      mode: EditMode.Resize,
      params: this.viewModel.getResizeParams(),
    });
  }

  protected refresh(): void {
    this.imageSize = this.imageSize$;
  }
}
